import { useCallback, useState } from 'react'
import { gql, useMutation } from '@apollo/client'
import { toast } from 'sonner'
import type { Editor } from '@tiptap/react'

const UPLOAD_FILE = gql`
  mutation UPLOAD_FILE($file: Upload!) {
    uploadFile(file: $file)
  }
`

export function useEditorImageUpload() {
  const [uploadFile] = useMutation(UPLOAD_FILE)
  const [isUploading, setIsUploading] = useState(false)

  const uploadAndInsert = useCallback(
    async (editor: Editor, file: File) => {
      setIsUploading(true)
      try {
        const { data } = await uploadFile({ variables: { file } })
        const url = data?.uploadFile
        if (url) {
          editor.chain().focus().setImage({ src: url, alt: file.name }).run()
        } else {
          toast.error('Image upload failed')
        }
      } catch (error) {
        console.error('Image upload error:', error)
        toast.error('Image upload failed')
      } finally {
        setIsUploading(false)
      }
    },
    [uploadFile]
  )

  return { uploadAndInsert, isUploading }
}
